var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "precise-query-box" }, [
    _c("div", { staticClass: "switch" }, [
      _c(
        "div",
        [
          _c("el-switch", {
            on: { change: _vm.handleChange },
            model: {
              value: _vm.autoTranslateSwitch,
              callback: function ($$v) {
                _vm.autoTranslateSwitch = $$v
              },
              expression: "autoTranslateSwitch",
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("autoTranslate")))]),
        ],
        1
      ),
      _c("div", [
        _c(
          "span",
          { staticClass: "text-btn ml10", on: { click: _vm.resetFields } },
          [_vm._v(_vm._s(_vm.$i18.language("重置")))]
        ),
      ]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.autoTranslateSwitch,
            expression: "autoTranslateSwitch",
          },
        ],
        staticClass: "translateCont",
      },
      [
        _c("div", [_vm._v(_vm._s(_vm.$t("components.translate.systemTran")))]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "translateCont-box",
          },
          _vm._l(_vm.keyWordsList, function (v, idx) {
            return _c("div", { key: idx }, [
              _c(
                "span",
                {
                  staticClass: "translateCont-key-item",
                  class: {
                    "translateCont-key-item-active":
                      _vm.checkedKeyword === v.value,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleCheckKey(v)
                    },
                  },
                },
                [_vm._v(_vm._s(v.value))]
              ),
            ])
          }),
          0
        ),
        _vm.val.value && _vm.val.trans && _vm.val.trans.length
          ? _c(
              "div",
              { staticClass: "translateCont-key-trans" },
              _vm._l(_vm.val.trans, function (item, index) {
                return _c(
                  "p",
                  { key: index, staticClass: "tranLine" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "tranCheck",
                        on: { change: _vm.changeCheckTrans },
                        model: {
                          value: item.check,
                          callback: function ($$v) {
                            _vm.$set(item, "check", $$v)
                          },
                          expression: "item.check",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              !_vm.lang ? item.language : item.languageCode
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "span",
                      { class: [item.checkEdit ? "" : "addBlue", "tranBlue"] },
                      [
                        _c("el-input", {
                          staticClass: "tranInput",
                          staticStyle: { width: "180px" },
                          attrs: {
                            readonly: item.checkEdit,
                            placeholder: _vm.$t("dashboardCont.enterContent"),
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.loseFocuse(item, _vm.val.value)
                            },
                          },
                          model: {
                            value: item.translate,
                            callback: function ($$v) {
                              _vm.$set(item, "translate", $$v)
                            },
                            expression: "item.translate",
                          },
                        }),
                        _c("div", [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    item.checkEdit &&
                                    item.originalTranslate !== item.translate,
                                  expression:
                                    "item.checkEdit&&item.originalTranslate!==item.translate",
                                },
                              ],
                              staticClass: "tranSure reset-refresh",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.resetItem(item, _vm.val.value)
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                staticClass: "newIcon imgShow",
                                attrs: { name: "uniE010" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "tranSure",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.editlanguage(item, _vm.val.value)
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.checkEdit,
                                    expression: "item.checkEdit",
                                  },
                                ],
                                staticClass: "newIcon imgShow",
                                attrs: { name: "translate-edit" },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !item.checkEdit,
                                      expression: "!item.checkEdit",
                                    },
                                  ],
                                  staticClass: "imgSure",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.translate.surceChange")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }